import classNames from 'styles/utils/classNames';

export interface ChipOption {
  key: string;
  label: string;
  iconSrc: string;
}

interface Props {
  options: ChipOption[];
  selectedKey: string | null;
  onSelect: (key: string | null) => void;
}

export default function FilterChips({ options, selectedKey, onSelect }: Props) {
  if (options.length === 0) {
    return null;
  }

  return (
    <div className="flex flex-wrap items-center gap-2">
      {options.map((option) => {
        const isSelected = option.key === selectedKey;

        return (
          <button
            key={option.key}
            type="button"
            onClick={() => onSelect(isSelected ? null : option.key)}
            className={classNames(
              'typography-product-element-label flex h-[1.875rem] items-center justify-center gap-1 rounded-lg px-ds-md py-ds-sm transition-colors',
              isSelected
                ? 'bg-color-bg-lightmode-invert text-color-text-lightmode-invert dark:bg-color-bg-darkmode-invert dark:text-color-text-darkmode-invert'
                : 'bg-color-bg-lightmode-secondary text-color-text-lightmode-secondary dark:bg-color-bg-darkmode-secondary dark:text-color-text-darkmode-secondary',
            )}
          >
            <img src={option.iconSrc} alt="" className="h-4 w-4 object-contain" />
            {option.label}
          </button>
        );
      })}
    </div>
  );
}
